const history = {
  title: "Meine Projekte",
  upgradeBtn: "Upgrade",
  subTitle: "Vergessen Sie nicht, Ihre Datei herunterzuladen, sie wird 24 Stunden später im Überfluss vorhanden sein.",
  MAgo: "vor {{num}} Minuten",
  HAgo: "{{num}} Stunden zuvor",
  DAgo: "{{num}} Stunden zuvor",
  justNow: "Gerade jetzt",
  originalFile: "Ursprüngliche Datei",
  selectAllBtn: "Alles auswählen",
  emptyTips: "Noch kein Proiekt. <1>Bearbeiten gehen</1>",
  deleteTips: "Möchten Sie es wirklich löschen?",
};

export default history;
